<template>
  <div
    class="loader"
    :class="{
      paused: props.paused,
    }"
  >
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  paused?: boolean;
}>();
</script>

<style lang="scss">
$height: 20px;

.loader {
  @apply flex justify-center items-center gap-0.5;
  height: $height;

  &.paused div {
    background-color: var(--iconDefault);
    animation-play-state: paused;
  }
}

.loader div {
  @apply w-1 rounded-[32px] scale-y-[0.2] bg-st-stBlue;

  height: $height;
  animation: wave 1.3s infinite ease-in-out;
}

@keyframes wave {
  25% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(0.2);
  }
}

.loader :nth-child(2) {
  animation-delay: 0s;
}

.loader :nth-child(4) {
  animation-delay: 0.4s;
}

.loader :nth-child(1) {
  animation-delay: 0.8s;
}

.loader :nth-child(3) {
  animation-delay: 1.2s;
}
</style>
